import api from "../config";

//  Create new role

export const createRoleAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/roles/create-role",
    data,
  });
  return response;
};

//  Get all roles (scoped to hotelId/admin)

export const getRolesAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/roles/list",
    data,
  });
  return response;
};

// Get single role by ID

export const getRoleByIdAPI = async (roleId) => {
  const response = await api({
    method: "GET",
    url: `api/v1/roles/${roleId}`,
  });
  return response;
};

//  Update role

export const updateRoleAPI = async ({ roleId, data }) => {
  const response = await api({
    method: "PUT",
    url: `api/v1/roles/${roleId}`,
    data,
  });
  return response;
};

//  Delete role

export const deleteRoleAPI = async ({ roleId, hotelId }) => {
  const response = await api({
    method: "DELETE",
    url: `api/v1/roles/${roleId}`,
    data: { hotelId },
  });
  return response;
};
